export default "__VITE_ASSET__bc1dbb1a__"